// extracted by mini-css-extract-plugin
module.exports = {"container":"BlockHeaderTypeB_container__rOo2V","content":"BlockHeaderTypeB_content__CF7Ac"};